<template>
  <span class="san-highlight">
    <template
      v-for="(part, partIndex) in parts"
      :key="partIndex"
    >
      <template
        v-for="(subPart, subPartIndex) in part"
        :key="subPartIndex"
      >
        <!-- {{ console.log('%csubPart', 'color:lime', subPart) }}
        {{ console.log('%cTagName', 'color:accent', subPart.isHighlighted ? highlightedTagName : nonHighlightedTagName) }} -->
        <component
          :is="highlightedTagName"
          v-if="subPart.isHighlighted"
          class="san-highlight--highlighted"
        >
          {{ subPart.value }}
        </component>
        <template v-else>
          {{ subPart.value }}
        </template>
      </template>

      <span v-if="partIndex !== parts.length - 1">{{ separator }}</span>
    </template>
  </span>
</template>

<script setup>
// import { computed } from 'vue'
// import { createHighlightComponent } from 'instantsearch-ui-components'
import { getHighlightedParts, getPropertyByPath, unescape } from 'instantsearch.js/es/lib/utils'
// import { createElement, Fragment } from '../util/pragma'

// const Highlight = createHighlightComponent({ createElement, Fragment })

const props = defineProps({
  hit: { type: Object, required: true },
  attribute: { type: String, required: true },
  highlightedTagName: { type: String, default: 'mark' },
  nonHighlightedTagName: { type: String, default: 'span' },
  highlightProperty: { type: String, default: '_highlightResult' },
  separator: { type: String, default: ', ' }
  // suit: { type: Function, required: true },
})

// const preTag = computed(() => `<${props.highlightedTagName}>`)
// const postTag = computed(() => `</${props.highlightedTagName}>`)

const property = getPropertyByPath(props.hit[props.highlightProperty], props.attribute) || []
const properties = Array.isArray(property) ? property : [property]

const parts = properties.map(singleValue => // eslint-disable-line
  getHighlightedParts(unescape(singleValue.value || '')).map(
    ({ value, isHighlighted }) => ({
      // We have to do this because Vue gets rid of TextNodes with a single white space
      value: value === ' ' ? '  ' : value,
      isHighlighted
    })
  )
)
// console.log('%cparts', 'color:lime', parts)

// function createHighlightPartComponent(_ref) {
//   var createElement = _ref.createElement;
//   return function HighlightPart(_ref2) {
//     var classNames = _ref2.classNames,
//       children = _ref2.children,
//       highlightedTagName = _ref2.highlightedTagName,
//       isHighlighted = _ref2.isHighlighted,
//       nonHighlightedTagName = _ref2.nonHighlightedTagName;
//     var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
//     return createElement(TagName, {
//       className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
//     }, children);
//   };
// }

// const a = h('span', {}, parts.map(function (part, partIndex) {
//   const isLastPart = partIndex === parts.length - 1
//   return h(Fragment, { key: partIndex }, part.map((sp, spi) => {
//     return h('mark', { key: spi, highlightedTagName, nonHighlightedTagName, isHighlighted: sp.isHighlighted }, sp.value)
//   }), !isLastPart && h('span', {
//     className: classNames.separator
//   }, separator))
// }))

// createElement(Highlight, {
//   classNames: {
//     root: this.suit(),
//     highlighted: this.suit('highlighted')
//   },
//   highlightedTagName: this.highlightedTagName,
//   nonHighlightedTagName: Fragment,
//   parts
// })

</script>
